angular.module("datiClienteRiscatto.components", []).component("datiClienteRiscatto", {
    templateUrl: "ng/components/riscattoAnticipato/datiClienteRiscatto/datiClienteRiscatto.view.html",
    bindings: {
        richiestePostVendita: "<",
        numContratto: "<",
        numModulo: "<",
        postVendita: "<",
        validateComponent: "&"
    },
    controllerAs: "datiClienteRiscattoCtrl",
    controller: function DatiClienteRiscatto(
        $RichiestePostVenditaService,
        $location,
    ) {
        var self = this;

        self.$onInit = function () {

            self.supportModel = {
                restIsPending: false,
                preventiveAccepted: false,
                preventivePrinted: false,
            }
            // checkValidityComponent();
        }
    }
})